import styled from 'styled-components';
import { ItemBox } from '../ItemCommons';

const ParcelContentBody = styled(ItemBox)`
  display: flex;
  padding: 12px;
`;

const ItemContent = styled.div`
  margin-left: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const ThumbnailWrapper = styled.div``;

const ItemDescription = styled.div``;

export { ParcelContentBody, ItemContent, ItemDescription, ThumbnailWrapper };
